import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Search, BadgeCheck, ShieldOff } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function AdminManagers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const refresh = () => api.get("/managers/?status=approved").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const f = items.filter(m => !q || (m.title || "").toLowerCase().includes(q.toLowerCase()) || (m.primary_role || "").toLowerCase().includes(q.toLowerCase()) || (m.user?.full_name || "").toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Manager</h1>
      <p className="text-sm text-slate-600 mb-4">Network di manager approvati.</p>
      <div className="mb-4 relative max-w-md"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" /><Input className="pl-9" placeholder="Cerca per nome, ruolo, titolo..." value={q} onChange={e => setQ(e.target.value)} /></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {f.map(m => (
          <div key={m.id} className="cxo-card p-5">
            <div className="flex items-start gap-3">
              <img src={m.photo} alt="" className="w-14 h-14 rounded-full object-cover" />
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-slate-900 truncate">{m.user?.full_name}</h3>
                <p className="text-xs text-slate-600">{m.title}</p>
              </div>
              {m.is_verified && <BadgeCheck size={18} className="text-[#2D6BFF]" />}
            </div>
            <p className="mt-3 text-xs text-slate-600">{m.primary_role}</p>
            <div className="mt-2 flex flex-wrap gap-1">{(m.industries || []).slice(0, 3).map(i => <Badge key={i} variant="outline" className="text-[10px]">{i}</Badge>)}</div>
            <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs">
              <div><p className="text-slate-500">Exp</p><p className="font-semibold cxo-tabular">{m.years_managerial}+</p></div>
              <div><p className="text-slate-500">Disp.</p><p className="font-semibold cxo-tabular">{m.monthly_availability_days}gg</p></div>
              <div><p className="text-slate-500">Tariffa</p><p className="font-semibold cxo-tabular">€{m.daily_rate_min}-{m.daily_rate_max}</p></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
